<div id="table_info" class="tablewrap resizetable tabpage hidden">
    <div class="table tableinfo">
        <table fixedcols="[0]" id="trackinfotable">
          <tr>
            <th><input type="checkbox"/></th>
            <th>{{'Type'|translate }}</th>
            <th class="datetime_column">{{'Start'|translate }}</th>
            <th class="datetime_column">{{'Finish'|translate }}</th>
            <th class="time_column">{{'Duration'|translate }}</th>
            <th>{{'Mileage'|translate }}</th>
            <th>{{'Avg. speed'|translate }}</th>
            <th>{{'Max. speed'|translate }}</th>
          </tr>
        </table>
    </div>
    <app-pagination [viewmode]="'print excel'" [printElementID]="'trackinfotable'"></app-pagination>
</div>
